<template>
  <div class="app-container">
    <menu-coupons-filter />
    <menu-coupons-table />
    <pagination v-show="total>0" @pagination="fetchData" />
    <el-dialog :title="getTitle" :visible="menuCouponVisible" :lock-scroll="false" @close="onCloseDialog()" :width="widthResize" class="modal-center" top="0">
      <modal ref="menuCouponModal"/>
    </el-dialog>
  </div>
</template>

<script>
  import Modal from '../manager/menu_coupons/Modal'
  import MenuCouponsFilter from '../manager/menu_coupons/Filter'
  import MenuCouponsTable from '../manager/menu_coupons/Table'
  import { mapActions, mapGetters, mapMutations } from 'vuex'
  export default {
    data() {
      return {
        windowWidth: '',
      }
    },
    created() {
      window.addEventListener('resize', this.handleResize)
      this.handleResize()
    },
    components: {
      Modal,
      MenuCouponsFilter,
      MenuCouponsTable,
    },
    computed: {
      widthResize() {
        return this.windowWidth > 768 ? '50%' : '95%'
      },
      ...mapGetters(['menuCouponVisible', 'total', 'queryMenuCoupon']),
      getTitle() {
        return '回数券管理登録'
      }
    },
    mounted() {
      this.fetchData()
    },
    methods: {
      ...mapActions('menu_coupon', ['fetchMenuCoupons', 'fetchClinicNameMenuCoupons']),
      ...mapMutations('menu_coupon', ['SET_MENU_COUPON_VISIBLE']),
      fetchData() {
        this.fetchMenuCoupons()
        this.fetchClinicNameMenuCoupons()
      },
      handleResize() {
        this.windowWidth = window.innerWidth;
      },
      onCloseDialog() {
        this.$refs.menuCouponModal.$refs['form'].resetFields()
        this.SET_MENU_COUPON_VISIBLE(false)
        document.body.classList.remove('modal-open');
      }
    }
  }
</script>

<style>
  .modal-center {
    display: flex;
    justify-content: center;
    align-items: center;
  }
</style>
